import { render, staticRenderFns } from "./ClientCallInfo.vue?vue&type=template&id=22c38972&"
import script from "./ClientCallInfo.vue?vue&type=script&lang=js&"
export * from "./ClientCallInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports